import { Info as InfoIcon, InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import type { MouseEvent, PointerEvent } from 'react';
import { useState } from 'react';

type Props = {
  tooltip: string;
};

const stopMenuSelection = (e: MouseEvent | PointerEvent) => {
  e.preventDefault();
  e.stopPropagation();
};

/** Per-option info icon inside dropdown / select menus. */
const VNFieldHelpItemTipIcon = ({ tooltip }: Props) => {
  const [tipOpen, setTipOpen] = useState(false);

  return (
    <Tooltip
      title={tooltip}
      placement="top"
      arrow
      disableInteractive
      open={tipOpen}
      onOpen={() => setTipOpen(true)}
      onClose={() => setTipOpen(false)}
      classes={{ tooltip: 'vn-field-help__mui-tooltip' }}
      PopperProps={{ sx: { zIndex: 1600 } }}
    >
      <span
        className={['vn-field-help-menu-item__icon-wrap', tipOpen ? 'vn-field-help-menu-item__icon-wrap--active' : '']
          .filter(Boolean)
          .join(' ')}
        onMouseDown={stopMenuSelection}
        onMouseDownCapture={stopMenuSelection}
        onClick={stopMenuSelection}
        onClickCapture={stopMenuSelection}
        onPointerDown={stopMenuSelection}
        onPointerDownCapture={stopMenuSelection}
      >
        <InfoOutlinedIcon
          className="vn-field-help-menu-item__icon vn-field-help-menu-item__icon--default"
          fontSize="small"
          aria-hidden="true"
        />
        <InfoIcon
          className="vn-field-help-menu-item__icon vn-field-help-menu-item__icon--highlighted"
          fontSize="small"
          aria-label="Option information"
        />
      </span>
    </Tooltip>
  );
};

export default VNFieldHelpItemTipIcon;
